"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortfolioHeadingMedium = exports.PortfolioHeadline = exports.Logo = exports.logoLargeStyling = exports.logoStyling = exports.PortfolioParagraph = exports.portfolioParagraphLargeStyling = exports.portfolioParagraphSmallStyling = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _MediaQueries = _interopRequireDefault(require("../MediaQueries"));

var _StyledTypography = require("../StyledTypography");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// 14/20 - 16/24
var portfolioParagraphSmallStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";", ""], function (props) {
  return props.theme.fontSizeBodySmall;
}, function (props) {
  return props.theme.lineHeightBodySmall;
}, _MediaQueries["default"].minWidth.portfolioDesktop(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.lineHeightBodyLarge;
})); // 18/28

exports.portfolioParagraphSmallStyling = portfolioParagraphSmallStyling;
var portfolioParagraphLargeStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.fontSizeBodyLarge;
}, function (props) {
  return props.theme.lineHeightPortfolioBodyLarge;
}); // 16/24 - 18/28

exports.portfolioParagraphLargeStyling = portfolioParagraphLargeStyling;
var PortfolioParagraph = (0, _styledComponents["default"])(_StyledTypography.Paragraph).withConfig({
  displayName: "Elements__PortfolioParagraph",
  componentId: "kfhv8-0"
})(["font-size:", ";line-height:", ";", " ", " ", " font-family:", ";", ";"], function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.lineHeightBodyLarge;
}, _MediaQueries["default"].minWidth.portfolioDesktop(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), function (props) {
  return props.theme.fontSizeBodyLarge;
}, function (props) {
  return props.theme.lineHeightPortfolioBodyLarge;
}), function (props) {
  return props.small && (0, _styledComponents.css)(["", ";"], portfolioParagraphSmallStyling);
}, function (props) {
  return props.large && (0, _styledComponents.css)(["", ";"], portfolioParagraphLargeStyling);
}, function (props) {
  return props.theme.portfolioFontFamily || props.theme.fontFamilyDefault;
}, function (props) {
  return props.hasHover && (0, _styledComponents.css)(["&:hover{a{color:", ";font-weight:bold;}};"], props.theme[props.colour]);
}); // 24/28

exports.PortfolioParagraph = PortfolioParagraph;
var logoStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.fontSizeLogo;
}, function (props) {
  return props.theme.lineHeightLogo;
}); // 28/32

exports.logoStyling = logoStyling;
var logoLargeStyling = (0, _styledComponents.css)(["font-size:", ";line-height:", ";"], function (props) {
  return props.theme.fontSizeLogoLarge;
}, function (props) {
  return props.theme.lineHeightLogoLarge;
}); // 22/28 - 28/32

exports.logoLargeStyling = logoLargeStyling;
var Logo = (0, _styledComponents["default"])(_StyledTypography.Paragraph).withConfig({
  displayName: "Elements__Logo",
  componentId: "kfhv8-1"
})(["", ";", " ", " font-family:", ";", ";"], logoStyling, _MediaQueries["default"].minWidth.portfolioDesktop(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n  "])), logoLargeStyling), function (props) {
  return props.large && (0, _styledComponents.css)(["", ";"], logoLargeStyling);
}, function (props) {
  return props.theme.portfolioFontFamily || props.theme.fontFamilyDefault;
}, function (props) {
  return props.hasHover && (0, _styledComponents.css)(["&:hover{a{color:", ";font-weight:bold;}};"], props.theme[props.colour]);
}); // 36/40 - 48/52
// Override medium minwidth

exports.Logo = Logo;
var PortfolioHeadline = (0, _styledComponents["default"])(_StyledTypography.Headline).withConfig({
  displayName: "Elements__PortfolioHeadline",
  componentId: "kfhv8-2"
})(["", " ", " font-family:", ";"], _MediaQueries["default"].minWidth.medium(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), function (props) {
  return props.theme.fontSizeHeadlineMobile;
}, function (props) {
  return props.theme.lineHeightHeadlineMobile;
}), _MediaQueries["default"].minWidth.portfolioDesktop(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: -0.4px;\n  "])), function (props) {
  return props.theme.fontSizeHeadline;
}, function (props) {
  return props.theme.lineHeightHeadline;
}), function (props) {
  return props.theme.portfolioFontFamily || props.theme.fontFamilyDefault;
}); // 24/28 - 28/32

exports.PortfolioHeadline = PortfolioHeadline;
var PortfolioHeadingMedium = (0, _styledComponents["default"])(_StyledTypography.HeadingMedium).withConfig({
  displayName: "Elements__PortfolioHeadingMedium",
  componentId: "kfhv8-3"
})(["", " font-family:", ";"], _MediaQueries["default"].minWidth.portfolioDesktop(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), function (props) {
  return props.theme.fontSizeHeadingPortfolio;
}, function (props) {
  return props.theme.lineHeightHeadingPortfolio;
}), function (props) {
  return props.theme.portfolioFontFamily || props.theme.fontFamilyDefault;
});
exports.PortfolioHeadingMedium = PortfolioHeadingMedium;